import { Link } from "react-router-dom";

import SalonBusinessCpaShell, { AccountingCard } from "./SalonBusinessCpaShell";

export default function SalonBusinessCpaTopicPage({
  title,
  description,
  sections = [],
}) {
  return (
    <SalonBusinessCpaShell
      title={title}
      description={description}
      actions={
        <Link
          to="/salonbusinesscpa"
          className="rounded-full border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50"
        >
          Back to dashboard
        </Link>
      }
    >
      <section className="grid gap-4 lg:grid-cols-3">
        {sections.map((section) => (
          <AccountingCard key={section.title} title={section.title} body={section.body}>
            {section.items?.length ? (
              <ul className="space-y-2 text-sm leading-6 text-slate-600">
                {section.items.map((item) => (
                  <li key={item} className="flex gap-2">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-rose-500" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            ) : null}
          </AccountingCard>
        ))}
      </section>
    </SalonBusinessCpaShell>
  );
}
